<div class="address-verification-dialog-wrapper">
  <h1 mat-dialog-title class="text-center">Address Verification</h1>

  <!-- Select Address To Use Layout -->
  @if (!selectedAddress) {
    <div class="select-address-content">
      <div class="current-address-section addresses-section">
        <div class="section-title">You Entered</div>
        <div class="address-card current-address">
          <!-- <div class="address-card-title">You Entered</div> -->
          <div class="address-card-content">
            <div class="address-line-1">{{ currentAddress?.street }}</div>
            <div class="address-line-2">
              @if (currentAddress?.city) {
                <span>{{ currentAddress?.city }},</span>
              }
              @if (currentAddress?.state) {
                <span>{{ currentAddress?.state }}</span>
              }
              @if (currentAddress?.zip) {
                <span>{{ currentAddress?.zip }}</span>
              }
            </div>
          </div>
          <div class="address-card-btn-wrapper">
            <button mat-stroked-button type="button" color="primary" class="address-card-btn" (click)="setActiveAddress(currentAddress)">Keep Original</button>
          </div>
        </div>
      </div>
      <div class="suggested-addresses-section addresses-section">
        <div class="section-title">More Addresses</div>
        <div class="suggested-addresses-list">
          @if (addressesSuggested?.length) {
            @for (_address of addressesSuggested; track _address; let i = $index) {
              <div class="address-card suggested-address">
                <!-- <div class="address-card-title">Recommended</div> -->
                <div class="address-card-content">
                  <div class="address-line-1">{{ _address?.street }}</div>
                  <div class="address-line-2">
                    @if (_address?.city) {
                      <span>{{ _address?.city }},</span>
                    }
                    @if (_address?.state) {
                      <span>{{ _address?.state }}</span>
                    }
                    @if (_address?.zip) {
                      <span>{{ _address?.zip }}</span>
                    }
                  </div>
                </div>
                <div class="address-card-btn-wrapper">
                  <button mat-flat-button type="button" color="primary" class="address-card-btn" (click)="setActiveAddress(_address)">Select</button>
                </div>
              </div>
            }
          } @else {
            <div class="address-card no-content">No Addresses To List</div>
          }
        </div>
      </div>
    </div>
  }

  <!-- Confirmation Layout -->
  @if (selectedAddress) {
    <div class="confirm-address-content">
      <div class="confirm-addresses-section addresses-section">
        <div class="section-title">Use selected address for lead</div>
        <div class="address-card confirm-address-info">
          <!-- <div class="address-card-title">Use selected address for lead</div> -->
          <div class="address-card-content">
            <div class="address-line-1">{{ selectedAddress?.street }}</div>
            <div class="address-line-2">
              @if (selectedAddress?.city) {
                <span>{{ selectedAddress?.city }},</span>
              }
              @if (selectedAddress?.state) {
                <span>{{ selectedAddress?.state }}</span>
              }
              @if (selectedAddress?.zip) {
                <span>{{ selectedAddress?.zip }}</span>
              }
            </div>
          </div>
          <div class="address-card-btn-wrapper duel-btns">
            <button mat-flat-button type="button" color="primary" class="address-card-btn" (click)="confirmSelection()">Confirm</button>
            <button mat-stroked-button type="button" color="primary" class="address-card-btn" (click)="setActiveAddress(null)">Change</button>
          </div>
        </div>
      </div>
    </div>
  }
</div>